import React, { useEffect, useRef } from "react";
import { Button, Menu, MenuItem, TextField } from "@mui/material";
import { faChevronRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import API_Routes from "../../../constants/api-routes";
import { setUserInfo } from "../../system/redux/reducers/roleReducer";
import { use } from "i18next";
import { useSelector, useDispatch } from "react-redux";
import { setCSRFInfo } from "../../system/redux/reducers/csrfReducer";
import { useTranslation } from "react-i18next";
import { setMenuInfo } from "../../system/redux/reducers/menuReducer";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { setReloadFeedbackDetails } from "../../system/redux/reducers/reloadFeedbackDetails";
import { setNavigationData, setPayloadData, setSearchFilterData } from "../../system/redux/reducers/NavigatedDataReducer";
import { datePickerAppDate, MISReportDateFormat } from "../../../constants/constants";
import moment from "moment";

function DropdownButton(props) {
  const today = moment().format(datePickerAppDate);
  var formattedDateToday = moment(today, datePickerAppDate).format(MISReportDateFormat);

  const toDateFormatted = formattedDateToday;
  console.log(toDateFormatted);
  //const fromDateCopy = new Date(today);
  //fromDateCopy.setDate(today.getDate() - 90);
  const fromDateFormatted = moment().subtract(3, 'month').format(datePickerAppDate);
  var formattedDateFrom = moment(fromDateFormatted, datePickerAppDate).format(MISReportDateFormat);
  const fromDate = formattedDateFrom;
  const { i18n, t } = useTranslation();
  const icon = props.icon;
  const menuItems = props.Menus;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [searchToken, setSearchToken] = React.useState([""]);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector(
    (state) => state.csrf
  );
  const StateRole = useSelector((state) => state.role);
  const searchRef = useRef();
  const handleClick = (event) => {
    event.stopPropagation();
    // if (searchRef.current) {
    //     searchRef.current.blur();
    // }
    setAnchorEl(event.currentTarget);
  };
  const handleSearchFocus = (event) => {
    // only focus the TextField when it should be focused...
    // if (searchRef.current) {
    //     searchRef.current.focus();
    // }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const headers = {
    Accept: "*/*",
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Credentials": true,
    "X-CSRF-TOKEN": csrfToken,
    // 'redirect': 'false'
  };

  const handleLanguageChange = (lang) => {
    console.log("Language Change");
    const langData = {
      lang: lang,
    };
    async function language(lang) {
      const response = await axios
        .get(
          API_Routes.setLanguage,
          {
            params: {
              lang,
            },
            withCredentials: "true",
          },
          headers
        )
        .then((res) => {
          console.log(res.status);
          if (res.status == 200) {
            console.log("Language change done");
            i18n.changeLanguage(lang);
          }
        });
    }
    language(lang);
    handleClose();
  };
  const handleSearchChange = (event) => {
    event.stopPropagation();
    setSearch(event.target.value);
    setSearchToken(event.target.value.split(" "));
  };
  const roleChangeHandler = (role) => {
    console.log(role);
    const roleData =
      "_csrf=" +
      csrfToken +
      "&id=" +
      role.id +
      "&department.id=" +
      role.departmentId;
    async function changeRole(roleData) {
      setSearch("");
      setSearchToken([""]);

      dispatch(setSearchFilterData(
        {
          "status": "All",
          "fromDate": fromDate,
          "toDate": toDateFormatted,
          "feedbackCode": "",
          "feedbackType": { "id": "" },
          "feedbackSource": { "id": "" },
          "area": { "id": "" },
          "subArea": { "id": "" },
          "user": { "id": "", "orgName": "", "email": "", "phone": "", "mobile": "" },
          "attributeList": [{ "attributeType": "", "departmentAttributeId": "", "attributeId": "", "mandatory": "", "attributeVal": "" }]
        },
      ));
      dispatch(setPayloadData({}));
      const navigationInfo = {
        'navigationPath': 'dashboard',
        'navigationSubPath': "All",
        'data': {}
      }
      dispatch(setNavigationData(navigationInfo));

      const response = await axios
        .post(
          API_Routes.changeRole,
          roleData,
          { withCredentials: "true" },
          headers
        )
        .then((res) => {
          
          console.log(res.status);
          if (res.status == 200) {
            console.log("Changing role");
            window.location.reload();


            /* axios
              .get(API_Routes.loginInfo, { withCredentials: true })
              .then((response) => {
                console.log("Inside login Info from role change");
                const userData = {
                  userEmail: " ",
                  homeLink: " ",
                  roles: " ",
                };
                const menuData = {
                  menuItems: [],
                };
                userData.userEmail = response.data.userEmail;
                userData.homeLink = response.data.homeLink;
                userData.roles = response.data.userRoles;
                userData.userId = response.data.userId;
                userData.userName = response.data.userName;
                userData.userCurrRole = { ...response.data.userCurrRole };
                menuData.menuItems = response.data.menus;
                console.log(userData);
                dispatch(setMenuInfo(menuData));
                dispatch(setUserInfo(userData));
                props.moveToDashboard("dashboard");
                // dispatch(setReloadFeedbackDetails({ reloadDashboard: true }));
                window.location.reload();
              })
              .catch((err) => {
                console.log(err);
              }); */
          }
        });
    }
    changeRole(roleData);
    handleClose();
  };
  useEffect(() => {
    console.log(props);
  });
  const MenuItem = ({ title, i, onClick }) => {
    return (
      <div style={{ padding: "1rem" }}>
        <a
          style={{
            padding: "10px 15px",
            backgroundColor: "inherit",
            cursor: "pointer",
            textDecoration: "none",
            color: "black",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#dee2e6")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "inherit")
          }
          onClick={onClick}
        >
          <FontAwesomeIcon icon={i} /> &nbsp; {title}
        </a>
      </div>
    );
  };
  return (
    // <div>
    //     <Button
    //         id="basic-button"
    //         aria-controls={open ? 'basic-menu' : undefined}
    //         aria-haspopup="true"
    //         aria-expanded={open ? 'true' : undefined}
    //         onClick={handleClick}
    //         color="inherit"
    //         variant="text"
    //     >
    //         <i class="ti ti-language text-black"></i>
    //         {/* <FontAwesomeIcon style={{ fontSize: "1.26rem", color: "grey" }} icon={icon}></FontAwesomeIcon> */}
    //     </Button>
    //     <Menu
    //         id="basic-menu"
    //         anchorEl={anchorEl}
    //         open={open}
    //         onClose={handleClose}
    //         disableRestoreFocus

    //         MenuListProps={{
    //             'aria-labelledby': 'basic-button',
    //         }}

    //     >
    //         {/* Invisible dummy element to handle auto fill from event triggered by menu*/}
    //         <TextField
    //             label="dummyfiled"
    //             value={"___"}
    //             hidden={true}
    //         />

    //         {menuItems.length > 10 && props.className.includes("role") && <TextField
    //             label="Search Roles"
    //             value={search}
    //             onChange={handleSearchChange}
    //             ref={searchRef}
    //             onFocus={handleSearchFocus}
    //             autoComplete="off"
    //             sx={{
    //                 width: '90%',
    //                 margin: '0 1rem',
    //             }}
    //         />}
    //         {props.className.includes("role") &&
    //             (() => {
    //                 return menuItems.filter(item => searchToken.every(token => (item.description.toLowerCase().includes(token.toLowerCase())||item.department.description.toLowerCase().includes(token.toLowerCase()))))
    //                 .map((item, index) => {
    //                     let crl = item.description;
    //                     let prefix = item.department.description;
    //                     let role = (prefix + " - " + crl.substring(crl.indexOf('_') + 1)).toUpperCase();
    //                     return (
    //                         <MenuItem key={index} title={role} i={index === 0 ? faCheck : faChevronRight} onClick={() => roleChangeHandler({ "id": item.id, "departmentId": item.department.id })} />
    //                     );
    //                 });

    //             })()
    //         }
    //         {menuItems.map((item, index) => {
    //             if (props.className.includes("language")) {
    //                 return (
    //                     <MenuItem key={index} title={item.title} i={item.icon} onClick={() => handleLanguageChange(item.key)} />
    //                 );
    //             }

    //         })}

    //     </Menu>
    // </div>

    <>
      {props.className.includes("language") && (
        <Dropdown>
          <Dropdown.Toggle
            variant="link"
            id="dropdown-basic"
            className="p-0 d-flex text-decoration-none"
          >
            <OverlayTrigger
              placement={'left'}
              overlay={
                <Tooltip>
                  {t('general.label.language')}
                </Tooltip>
              }
            >
              <i class="ti ti-language text-black"></i>
            </OverlayTrigger>

          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleLanguageChange("en")}>
              {t("general.label.english")}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleLanguageChange("hi")}>
              {t("general.label.hindi")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
      {props.className.includes("role") && (
        <>
          <Dropdown>
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              className="p-0 d-flex text-decoration-none"
            >
              <i class="ti ti-a-b-2 text-black"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="role-switch-area overflow-hidden">
              {menuItems.length > 10 && props.className.includes("role") && (
                // <TextField
                //   label="Search Roles"
                //   value={search}
                //   onChange={handleSearchChange}
                //   ref={searchRef}
                //   onFocus={handleSearchFocus}
                //   autoComplete="off"
                //   sx={{
                //     width: "90%",
                //     margin: "0 1rem",
                //   }}
                // />
                <Form className="p-3">
                  <InputGroup className="">
                    <Form.Control
                      placeholder="Search Roles"
                      aria-label="Search"
                      aria-describedby="basic-addon1"
                      className="border-end-0"
                      value={search}
                      onChange={handleSearchChange}
                      ref={searchRef}
                      onFocus={handleSearchFocus}
                    />
                    <InputGroup.Text id="basic-addon1" className="bg-white">
                      <i class="ti ti-search text-dark fs-5"></i>
                    </InputGroup.Text>
                  </InputGroup>
                </Form>
              )}
              <div className="role-name overflow-auto">
                {menuItems
                  .filter((item) =>
                    searchToken.every(
                      (token) =>
                        item.description
                          .toLowerCase()
                          .includes(token.toLowerCase()) ||
                        item.department.description
                          .toLowerCase()
                          .includes(token.toLowerCase())
                    )
                  )
                  .map((item, index) => {
                    let crl = item.description;
                    let prefix = item.department.description;
                    let role = (
                      prefix +
                      " - " +
                      crl.substring(crl.indexOf("_") + 1)
                    ).toUpperCase();
                    return (
                      <Dropdown.Item
                        key={index}
                        className="fw-medium"
                        onClick={() =>
                          roleChangeHandler({
                            id: item.id,
                            departmentId: item.department.id,
                          })
                        }
                      >
                        <i
                          className={
                            (StateRole.userCurrRole.id === item.id && StateRole.userCurrRole.department.id === item.department.id) ? "ti ti-check" : "ti ti-chevron-right"
                          }
                        ></i>
                        {role}
                      </Dropdown.Item>
                    );
                  })}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
    </>
  );
}

export default DropdownButton;
